import {error_modal, success_modal} from "../functions/functions";

export function remove_err_in_url()
{
    if(window.location.href.search('err=')!==-1) {
        let winUrlSplitByQuestion = window.location.href.split('?');
        let winUrlSplitByAnd = winUrlSplitByQuestion[1].split('&');
        let newHRef = '';
        if (winUrlSplitByQuestion[1] !== undefined && winUrlSplitByQuestion[1] !== null && winUrlSplitByQuestion[1].trim() !== '') {
            newHRef = newHRef + winUrlSplitByQuestion[0];
            if (winUrlSplitByAnd.length > 1) {
                let count = 0;
                winUrlSplitByAnd.forEach(element => {
                    if (element.search('err=') < 0) {
                        if (count === 0) {
                            newHRef = newHRef + '?' + element;
                            if ((winUrlSplitByAnd.length - 2) > count) {
                                newHRef = newHRef + '&';
                            }
                        } else {
                            newHRef = newHRef + element;
                            if ((winUrlSplitByAnd.length - 2) > count) {
                                newHRef = newHRef + '&';
                            }
                        }
                        count = count + 1;
                    }
                });
            }
            window.history.pushState({}, document.title, newHRef);
        }
    }
}